import React from "react";
import { Link } from "gatsby";
import cx from "classnames";
import { useLocation } from "@reach/router";

import { ChevronDown, ChevronUp, MapleLeaf } from "@components/Icon";

import { MenuItem } from "../menuConfig";

import styles from "./index.module.scss";

const NavMenuItem: React.FC<{
  item: MenuItem;
  isScrolled?: boolean;
  openMenu: string | null;
  setOpenMenu: (id: string | null) => void;
}> = ({ item, isScrolled, openMenu, setOpenMenu }) => {
  const location = useLocation();

  const isOpen = openMenu === item.id;
  const hasSubItems = item.subItems && item.subItems.length > 0;
  const isSubItemActive =
    hasSubItems && item.subItems?.some((subItem) => subItem.path === location.pathname);
  const isActive = !hasSubItems && location.pathname === item.path;
  if (!hasSubItems && item.path) {
    return (
      <div className={styles.NavMenu}>
        <Link to={item.path}>
          <button
            className={cx(styles.NavLink, {
              [styles.DarkLink]: isScrolled,
              [styles.NavLinkActive]: isActive,
              [styles.DarkLinkActive]: isScrolled && isActive
            })}
          >
            {item.id === "infoway" && <MapleLeaf size={16} />}
            {item.label}
          </button>
        </Link>
      </div>
    );
  }

  return (
    <div
      className={styles.NavMenu}
      onMouseEnter={() => setOpenMenu(item.id)}
      onMouseLeave={() => setOpenMenu(null)}
    >
      <button
        className={cx(styles.NavLink, {
          [styles.DarkLink]: isScrolled,
          [styles.NavLinkActive]: isSubItemActive,
          [styles.DarkLinkActive]: isScrolled && isSubItemActive
        })}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-controls={`${item.id}-menu`}
      >
        {item.label}
        {isOpen ? <ChevronUp /> : <ChevronDown size={20} />}
      </button>
      {hasSubItems && (
        <div className={styles.Menu} id={`${item.id}-menu`} data-visible={isOpen}>
          {item.subItems?.map((subItem, index) => {
            const isActive = subItem.path === location.pathname;
            return (
              <Link
                key={`${item.id}-subitem-${index}`}
                to={subItem.path}
                className={styles.SubLink}
              >
                {isActive && <span className={styles.ActiveSubLinkIndicator}></span>}
                <span
                  className={cx(styles.SubLinkText, {
                    [styles.SubLinkTextActive]: isActive
                  })}
                >
                  {subItem.label}
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NavMenuItem;
